import type { NetworkFluidType } from './types';

/** Fill colours copied from the Nemo SVG assets (hot_water.svg / cold_water.svg) — graphic asset, not UI tokens. */
const FLUID_ICON: Record<NetworkFluidType, { fill: string; label: string }> = {
    hot_water: { fill: '#F34E46', label: 'Eau chaude' },
    cold_water: { fill: '#007ACD', label: 'Eau froide' },
    steam: { fill: '#778C9B', label: 'Vapeur' },
};

export const FLUID_TYPE_LABEL: Record<NetworkFluidType, string> = {
    hot_water: 'Chaud',
    cold_water: 'Froid',
    steam: 'Vapeur',
};

const BOOKMARK = 'M17.7143 2H6.28571C5.02857 2 4.01143 3 4.01143 4.22222L4 22L12 18.6667L20 22V4.22222C20 3 18.9714 2 17.7143 2Z';
const DROP =
    'M14.9844 11.6357C14.9083 10.8171 14.4723 8.52986 11.9999 6C9.52643 8.53123 9.09116 10.8194 9.01576 11.6311C8.99751 11.8292 9.00007 11.9385 9.00019 11.9436V11.9448C9.00019 13.6321 10.3432 15 12 15C13.6568 15 15 13.6321 15 11.9448L14.9998 11.9424C15 11.9323 15.0019 11.8249 14.9844 11.6357Z';
const SNOWFLAKE =
    'M17.8327 9.41675H15.4002L17.2902 7.52675L16.4677 6.69842L13.7493 9.41675H12.5827V8.25008L15.301 5.53175L14.4727 4.70925L12.5827 6.59925V4.16675H11.416V6.59925L9.52602 4.70925L8.69768 5.53175L11.416 8.25008V9.41675H10.2493L7.53102 6.69842L6.70852 7.52675L8.59852 9.41675H6.16602V10.5834H8.59852L6.70852 12.4734L7.53102 13.3017L10.2493 10.5834H11.416V11.7501L8.69768 14.4684L9.52602 15.2909L11.416 13.4009V15.8334H12.5827V13.4009L14.4727 15.2909L15.301 14.4684L12.5827 11.7501V10.5834H13.7493L16.4677 13.3017L17.2902 12.4734L15.4002 10.5834H17.8327V9.41675Z';

/** Network type icon — same bookmark SVG as Nemo (red = hot water, blue = cold water, grey = steam). */
export function Size2MixNetworkIcon({ fluidType, size = 24 }: { fluidType: NetworkFluidType; size?: number }) {
    const def = FLUID_ICON[fluidType];
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label={def.label} style={{ flexShrink: 0 }}>
            <title>{def.label}</title>
            <path d={BOOKMARK} fill={def.fill} />
            <path d={fluidType === 'cold_water' ? SNOWFLAKE : DROP} fill="#FFFFFF" />
        </svg>
    );
}
